import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/home/Home.vue'
import MyTask from '@/views/mytask'
import Task from '@/views/task'
import Me from '@/views/me'
import Personal from '@/views/personal'
import Bankc from '@/views/personal/bankc'
import Branch from '@/views/personal/branch'
import Login from '@/views/login'
import Bos from '@/views/login/bos'
import Dtalk from '@/views/login/dtalk'
import Register from '@/views/login/register'
import Perfect from '@/views/login/perfect'
import Account from '@/views/me/account'
import Userinfo from '@/views/me/userinfo'
import Money from '@/views/me/money'
import oldMoney from '@/views/me/money-history'
import GetTask from '@/views/task/getTask'
import OldTask from '@/views/task/oldTask'
import TaskType from '@/views/mytask/taskType'
import Details from '@/views/mytask/details'
import Dynamic from '@/views/mytask/dynamic'
import Question from '@/views/mytask/question'
import Share from '@/views/me/share/share'
import Myshare from '@/views/me/share/myshare'
import Friend from '@/views/me/share/friend'
import Tasking from '@/views/me/share/tasking'
import Invoice from '@/views/introduction/invoice'
import Profit from '@/views/introduction/profit'
import Finish from '@/views/introduction/finish'
import Explain from '@/views/introduction/explain'
import Evaluate from '@/views/task/evaluate'
import Public from '@/views/me/public'

import store from '@/store'
import Cookies from 'js-cookie'

Vue.use(VueRouter)
  const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    children:[
      {
        path: '/home/mytask',
        component: MyTask,
        name: 'mytask',
        meta: {
          title: '我的任务'
        }
      },
      {
        path: '/home/task',
        name: 'HomeTask',
        component: Task,
        meta: {
          title: '任务大厅'
        }
      },
      {
        path: '/home/interview',
        name: 'interview',
        component: ()=> import('@/views/interview'),
        meta: {
          title: '简历筛选'
        }
      },
      {
        path: '/me',
        component: Me,
        meta: {
          title: '个人中心'
        }
      },
      {
        path: '/home',
        redirect: '/home/task'
      }
    ]
  },
  {
    path: '/interviewInfo',
    name: 'interviewInfo',
    component: ()=> import('@/views/interview/info'),
    meta: {
      title: '简历详情'
    }
  },
  {
    path: '/addResume',
    name: 'addResume',
    component: ()=> import('@/views/interview/addResume'),
    meta: {
      title: '新增简历'
    }
  },
  {
    path: '/addAssessment',
    name: 'addAssessment',
    component: ()=> import('@/views/interview/addAssessment'),
    meta: {
      title: '填写评估'
    }
  },
  {
    path: '/InitiateInterview',
    name: 'InitiateInterview',
    component: ()=> import('@/views/interview/InitiateInterview'),
    meta: {
      title: '发起面试'
    }
  },
  {
    path: '/evaluate',
    component: Evaluate,
    meta: {
      title: '选择标签'
    }
  },
  {
    path: '/pdf',
    component: ()=> import('../views/other/pdf'),
    meta: {
      title: 'pdf'
    }
  },
  {
    path: '/test',
    component: ()=> import('../views/test'),
    meta: {
      title: 'test'
    }
  },
  {
    path: '/account',
    component: Account,
    meta: {
      title: '账号信息'
    }
  },
  {
    path: '/share',
    component: Share,
    meta: {
      title: '分享'
    }
  },
  {
    path: '/userinfo',
    component: Userinfo,
    meta: {
      title: '个人资料'
    }
  },
  {
    path: '/public',
    component: Public,
    meta: {
      title: '我的发布'
    }
  },
  {
    path: '/lookData',
    component:  () => import("@/views/me/lookData"),
    meta: {
      title: '数据查看'
    }
  },
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/retrievePassword',
    name: 'retrievePassword',
    component: ()=> import('@/views/login/retrievePassword'),
    meta: {
      title: '找回密码'
    }
  },
  {
    path: '/dtalk',
    name: 'Dtalk',
    component: Dtalk,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/bos',
    name: 'Bos',
    component: Bos,
    meta: {
      title: '登录'
    },
    children: [
      {
        path: 'register',
        name: 'Register',
        component: Register,
        meta: {
          title: '完善'
        }
      },
      {
        path: 'perfect',
        name: 'Perfect',
        component: Perfect,
        meta: {
          title: '完善'
        }
      },
    ]
  },
  {
    path: '/get',
    name: 'Get',
    component: GetTask,
    meta: {
      title: '获取任务'
    }
  },
  {
    path: '/taskType',
    name: 'taskType',
    component: TaskType,
    meta: {
      title: '我的任务'
    },
    children: [
      {
        path: 'details',
        name: 'Details',
        component: Details,
      },
      {
        path: 'dynamic',
        name: 'Dynamic',
        component: Dynamic,
      },
      {
        path: 'question',
        name: 'Question',
        component: Question,
      }
    ]
  },
  {
    path: '/money',
    name: 'Money',
    component: Money,
    meta: {
      title: '我的奖金'
    }
  },
  {
    path: '/oldmoney',
    name: 'oldMoney',
    component: oldMoney,
    meta: {
      title: '奖金历史'
    }
  },
  {
    path: '/personal',
    name: 'Personal',
    component: Personal,
    meta: {
      title: '账户',
      keepalive: true
    }
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: Invoice,
    meta: {
      title: '开票流程'
    }
  },
  {
    path: '/bankc',
    name: 'Bankc',
    component: Bankc,
    meta: {
      title: '银行类型'
    }
  },
  {
    path: '/branch',
    name: 'Branch',
    component: Branch,
    meta: {
      title: '银行支行'
    }
  },
  {
    path: '/profit',
    name: 'Profit',
    component: Profit,
    meta: {
      title: '群英荟收益秘诀'
    }
  },
  {
    path: '/explain',
    name: 'Explain',
    component: Explain,
    meta: {
      title: '什么是群英荟'
    }
  },
  {
    path: '/finish',
    name: 'Finish',
    component: Finish,
    meta: {
      title: '群英荟接单指引'
    }
  },
  {
    path: '/oldTask',
    name: 'oldTask',
    component: OldTask,
    meta: {
      title: '已领任务'
    }
  },
  {
    path: '/myshare',
    name: 'Myshare',
    component: Myshare,
    meta: {
      title: '我的分享'
    },
    children: [
      {
      path: 'friend',
      name: 'Friend',
      component: Friend
      },
      {
        path: 'tasking',
        name: 'Tasking',
        component: Tasking
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to,from,next) => {
  let token = store.getters.token
  const logout = ['Login','HomeTask','retrievePassword','Register','Perfect','Bos','Get','Explain','Invoice','Profit','Finish','HomeTask','Home','Dtalk']
  if (!token) {
    token = Cookies.get('token')
    store.commit('SET_TOKEN', token)
  }
  if (logout.indexOf(to.name) !== -1) {
    next()
  } else if (to && !token) {
    router.replace('/login')
  } else {
    next()
  }
})

export default router
